import './landing-forms.scss';
import ApplicationForm from "./parts/ApplicationForm";

let loaderSelector = meetupFormsData && meetupFormsData?.loader || '';
let restUrl = meetupFormsData && meetupFormsData?.restUrl || '';
let restAction = meetupFormsData && meetupFormsData?.action || '';
let template = meetupFormsData && meetupFormsData?.template || '';

function createForm(htmlString, index) {
    let formHtml = htmlString.replaceAll('[0]', '-' + index);

    var div = document.createElement('div');
    div.innerHTML = formHtml.trim();

    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}

if (document.querySelectorAll(loaderSelector)) {
    let formData = {
        action: restAction,
        template: template,
    };
    let encodedData = JSON.stringify(formData);

    fetch(restUrl, {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: encodedData
    })
        .then(res => res.json())
        .then(response => {
            if (response?.data) {
                response.data.forEach((el) => {
                    let places = document.querySelectorAll(loaderSelector + '[data-form="' + el.id + '"]');
                    places.forEach(place => {
                        let form = createForm(el.html);
                        let settings = {
                            sendRestUrl : meetupFormsData.sendRestUrl,
                            'successMessage' : response?.successMessage,
                            'errorMessage' : response?.errorMessage,
                            'shortSuccessMessage' : response?.shortSuccessMessage,
                            'template' : meetupFormsData?.template,
                        }
                        new ApplicationForm(form, settings, place);
                    });
                })
            }
        })
        .catch(error => {
            console.log(error);
        });
}
